export default "__VITE_ASSET__DEsHFbSr__"